<template>
<div class="page-container">
  <el-breadcrumb separator="/">
    <el-breadcrumb-item>
      <span class="page-title">基金会</span>
    </el-breadcrumb-item>
    <el-breadcrumb-item>投资记录</el-breadcrumb-item>
  </el-breadcrumb>
  <el-card class="page-content" shadow="never">
    <div class="page-actions">
      <el-input placeholder="请输入基金会ID" clearable v-model="foundationId">
      </el-input>
      <el-input placeholder="请输入账号ID" clearable v-model="userId">
      </el-input>
      <el-button @click="handleSearch" type="primary">搜索</el-button>
    </div>
    <list @refresh="getList"></list>
  </el-card>
</div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import List from './components/list';

export default {
  name: 'foundationRecords',
  data() {
    return {
      foundationId: '',
      userId: ''
    };
  },
  components: {
    List
  },
  computed: {
    ...mapState('foundationRecord', ['pagination'])
  },
  methods: {
    ...mapActions('foundationRecord', ['getRecords']),
    handleSearch() {
      this.getList({
        page: 1
      });
    },
    getList(data = {}) {
      const params = {};
      if (this.userId) {
        params.userId = this.userId;
      }
      if (this.foundationId) {
        params.foundationId = this.foundationId;
      }
      this.getRecords({
        ...params,
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    if (this.$route.params.foundationId) {
      this.foundationId = this.$route.params.foundationId;
      this.getList();
    }
  }
};
</script>
